// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"153":"9de5cb77","260":"14656d6f","668":"7f60f21c","762":"7a4d651a"}[chunkId] + ".js";
};